<template>
    <div class="columns">
        <section class="section column is-2 menu-background">
            <Menu />
        </section>
        <section class="column is-10">
            <div class="navbar-custom-pc">
                <NavBar />
            </div>
            <div>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <span class="is-size-3 has-text-weight-bold">Estimate</span>
                            <span style="margin-left:25px">
                                <b-button type="is-info" icon-pack="fas" icon-left="fas fa-plus-circle"
                                    @click="newInvoice">
                                    New
                                </b-button>
                            </span>
                            <span style="margin-left:25px">
                                <b-button type="is-warning" icon-pack="fas" icon-left="fas fa-print" @click="print">
                                    Print
                                </b-button>
                            </span>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <b-field label="Date" horizontal>
                                <b-datepicker v-model="invoiceDate" locale="en-GB" placeholder="Select date"
                                    icon-pack="fas" icon="fas fa-calendar" trap-focus>
                                </b-datepicker>
                            </b-field>


                        </div>

                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <b-field label="Invoice" horizontal>
                                <b-input v-model="invoiceNoComputed" placeholder="1" icon-pack="fas"
                                    icon="fas fa-receipt">
                                </b-input>
                            </b-field>

                        </div>
                    </div>
                </div>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <p class="subtitle">
                                Bill Type
                            </p>

                        </div>

                    </div>
                    <div class="level-right">
                        <b-field label="Type" horizontal>
                            <b-radio v-model="documentTitle" name="estimate" native-value="ESTIMATE">
                                Estimate
                            </b-radio>
                            <b-radio v-model="documentTitle" name="invoice" native-value="INVOICE">
                                Invoice
                            </b-radio>
                        </b-field>
                    </div>
                    <div class="level-right">
                        <b-field label="Price" horizontal>
                            <b-radio type="is-danger" v-model="priceType" name="Retail" native-value="retail">
                                Retail
                            </b-radio>
                            <b-radio type="is-danger" v-model="priceType" name="wholesale" native-value="wholesale">
                                Wholesale
                            </b-radio>
                        </b-field>
                    </div>
                </div>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <p class="subtitle">
                                Billing address
                            </p>

                        </div>

                    </div>
                    <div class="level-right">
                        <b-field label="Name" horizontal>
                            <b-input v-model="invoice_data.client.company" placeholder="John Doe" icon-pack="fas"
                                icon="fas fa-id-badge">
                            </b-input>
                        </b-field>
                    </div>
                    <div class="level-right">
                        <b-field label="Address" horizontal>
                            <b-input v-model="invoice_data.client.address" placeholder="Kottayam,Kerala" icon-pack="fas"
                                icon="fas fa-address-card">
                            </b-input>
                        </b-field>
                    </div>
                </div>

                <div>
                    <b-table :data="isEmpty ? [] : product">
                        <b-table-column label="#" v-slot="props">
                            <span>{{props.index + 1}}</span>
                        </b-table-column>
                        <b-table-column label="Product" v-slot="props">
                            <template>
                                <b-autocomplete class = "custom-background-autocomplete" v-model="props.row.product_name_copy" style="width:300px !important"
                                    icon-pack="fas" icon="fas fa-search" :data="productData"
                                    placeholder="Search Product..." field="title" :loading="props.row.isFetching"
                                    @typing="input =>searchProduct(input,props.index)"
                                    @select="option => addProducts(option,props.index)"
                                    @blur="props.row.product_name_copy = props.row.product_name">

                                    <template slot-scope="props">
                                        <div class="media">
                                            <div class="media-content">
                                                <span class="has-text-weight-medium is-size-7">Code : <b>{{ props.option.product_id }}</b> </span>
                                                <br>
                                                <b>{{ props.option.product_name }}</b>
                                                <br>
                                                <small>
                                                    {{ props.option.family_name }}
                                                </small>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- <template #header slot-scope="props">
                                        <a @click="option => addCustomProduct(props.index)">
                                            <span> Add new... </span>
                                        </a>
                                    </template> -->
                                    <template #empty>
                                        <b-button type="is-primary" icon-pack="fas" icon-left="fas fa-plus"
                                            @click="option => addCustomProduct(props.index)">
                                            Add New
                                        </b-button>
                                    </template>
                                </b-autocomplete>
                            </template>
                        </b-table-column>
                        <b-table-column label="Quantity" v-slot="props">
                            <template>
                                <b-input placeholder="1" icon-pack="fas" icon="fas fa-balance-scale-right"
                                    v-model="props.row.quantity" required>{{props.row.quantity}}</b-input>
                            </template>

                        </b-table-column>
                        <b-table-column label="Rate" v-slot="props">
                            <template v-if="priceType == 'retail'">
                                <b-input placeholder="1.0" icon-pack="fas" icon="fas fa-mobile-alt"
                                    v-model="props.row.retail_price_alpha" required> ₹{{props.row.retail_price_alpha}}
                                </b-input>
                            </template>
                            <template v-else>
                                <b-input placeholder="1.0" icon-pack="fas" icon="fas fa-mobile-alt"
                                    v-model="props.row.wholesale_price" required> ₹{{props.row.wholesale_price}}
                                </b-input>
                            </template>

                        </b-table-column>

                        <b-table-column label="Total" v-slot="props">
                            <span v-if="props.row.retail_price_alpha == undefined || props.row.quantity == undefined">
                                ₹0
                            </span>
                            <span v-else-if="priceType == 'retail'">
                                ₹{{ props.row.retail_price_alpha * props.row.quantity }}
                            </span>
                            <span v-else>
                                ₹{{ props.row.wholesale_price * props.row.quantity }}
                            </span>
                        </b-table-column>
                        <b-table-column label="Select GST" v-slot="props">
                            <b-field>
                                <b-radio-button v-model="props.row.tax" native-value=0 type="is-danger">
                                    <span>0%</span>
                                </b-radio-button>
                                <b-radio-button v-model="props.row.tax" native-value=5 type="is-info">
                                    <span>5%</span>
                                </b-radio-button>
                                <b-radio-button v-model="props.row.tax" native-value=12 type="is-success">
                                    <span>12%</span>
                                </b-radio-button>
                                <b-radio-button v-model="props.row.tax" native-value=18 type="is-primary">
                                    18%
                                </b-radio-button>
                            </b-field>
                        </b-table-column>
                        <b-table-column label="Total incl. GST" v-slot="props">
                            <span v-if="props.row.retail_price_alpha == undefined || props.row.quantity == undefined">
                                ₹0
                            </span>
                            <span v-else-if="priceType == 'retail'">
                                ₹{{ (props.row.retail_price_alpha * props.row.quantity * (props.row.tax)/100) + props.row.retail_price_alpha * props.row.quantity }}
                            </span>
                            <span v-else>
                                ₹{{ (props.row.wholesale_price * props.row.quantity * (props.row.tax)/100) + props.row.wholesale_price * props.row.quantity }}
                            </span>
                        </b-table-column>
                        <b-table-column label="Remove" v-slot="props">
                            <b-button type="is-danger" outlined icon-pack="fas" icon-right="fas fa-trash"
                                @click="deleteProduct(props.index)" />
                        </b-table-column>
                        <template #footer>
                            <div class="has-text-right" style="margin-right:100px; !important">


                                <b-tag type="is-dark" size="is-medium">Grand Total : </b-tag>
                                <b-tag type="is-info" size="is-medium">₹{{grandTotal}}</b-tag>

                            </div>
                        </template>
                    </b-table>

                </div>
            </div>
            <b-loading :is-full-page=true v-model="isLoading" :can-cancel=false>
                <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin">
                </b-icon>
            </b-loading>
        </section>
    </div>
</template>

<script>
    import easyinvoice from 'easyinvoice'
    import NavBar from '@/components/NavBar.vue'
    import Menu from '@/components/Menu.vue'
    export default {
        name: "EstimateGST",
        components: {
            NavBar,
            Menu
        },
        data() {
            return {
                product: [{
                    isFetching: false
                }],
                isEmpty: false,
                productData: [],
                invoiceDate: new Date(),
                documentTitle: 'ESTIMATE',
                priceType: 'retail',
                invoice_data: {
                    "documentTitle": "",
                    "currency": "INR",
                    "taxNotation": "GST", //or gst
                    "marginTop": 25,
                    "marginRight": 25,
                    "marginLeft": 25,
                    "marginBottom": 25,
                    "logo": "https://img.icons8.com/ios/452/estimate.png", //or base64
                    //"logoExtension": "png", //only when logo is base64
                    "sender": {
                        "company": "",
                        "address": "",
                        "zip": "",
                        "city": "",
                        "country": "",
                    },
                    client: {
                        "company": "",
                        "address": "",
                        "zip": "",
                        "city": "",
                        "country": ""
                    },
                    "invoiceNumber": this.invoiceNoComputed,
                    "invoiceDate": new Date(),
                    "products": [],
                    "bottomNotice": "GST included 0%, 5%, 12%, 18%"
                },
                isLoading: false,
                sender: {
                    "company": "Kerala Cotton Stores",
                    "address": "Market Road",
                    "zip": "686101",
                    "city": "Changanacherry",
                    "country": "GST No. 32AOXPA3485N1ZE",
                },
            }
        },
        methods: {

            print() {
                // this.product alwasys contain 1 element
                if (this.product.length > 1) {
                    this.isLoading = true
                    let invoice_date = new Date(this.invoiceDate)

                    const new_date = invoice_date.toLocaleString().split('T')[0].split(',')[0].split('/')
                    const updated_date = `${new_date[1]}/${new_date[0]}/${new_date[2]}`
                    console.log(updated_date)
                    this.invoice_data.invoiceDate = updated_date
                    let product_copy = []
                    Object.assign(product_copy, this.product)
                    product_copy.splice(product_copy.length - 1, 1)

                    let updated_products = product_copy.map((product, index) => {
                        let product_details = {
                            description: `${++index}. ${product.description}`,
                            tax: product.tax || 0,
                            price: this.priceType == 'retail' ? product.retail_price_alpha : product.wholesale_price,
                            quantity: product.quantity
                        }
                        return product_details
                    })

                    this.invoice_data.products = updated_products
                    // document title
                    this.invoice_data.documentTitle = this.documentTitle
                    if (this.documentTitle == "INVOICE") {
                        this.invoice_data.sender = this.sender
                    } else {
                        this.invoice_data.sender = {
                            "company": "",
                            "address": "",
                            "zip": "",
                            "city": "",
                            "country": "",
                        }
                    }
                    const pdf_file_name = `#${this.invoice_data.invoiceNumber} ${this.invoice_data.client.company} ${new_date[1]}-${new_date[0]}-${new_date[2]}`
                    console.log(pdf_file_name)
                    easyinvoice.createInvoice(this.invoice_data, function (result) {

                        easyinvoice.download(pdf_file_name, result.pdf)
                        //	you can download like this as well:
                        //	easyinvoice.download();
                        //	easyinvoice.download('myInvoice.pdf');   
                    })
                    if (this.invoice_data.invoiceNumber.startsWith('B2C')) {
                        let temp_invoice_number = this.invoice_data.invoiceNumber.split('B2C')['1']
                            this.$store.dispatch('updateInvoiceNo')
                                .then(() => {

                                }).catch((error) => {
                                    console.log(error)
                                })
                                .finally(() => {
                                    this.isLoading = false
                                })
                        this.isLoading = false
                    } else {
                        this.isLoading = false
                    }


                }

            },
            searchProduct(input, index) {

                this.product[index].isFetching = true
                if (input) {

                    this.$store.dispatch('searchProduct', input)
                        .then((response) => {
                            this.productData = []
                            let updated_products = []
                            updated_products = response.result.product_data.map((product) => {
                                const product_details = {
                                    ...product,
                                    product_name_copy: product.product_name
                                }
                                return product_details
                            })
                            this.productData.push(...updated_products)

                        })
                        .catch(() => {
                            this.ToastError('Problem searching products')
                        })
                        .finally(() => {
                            this.product[index].isFetching = false
                        })
                }

            },
            addProducts(item, index) {

                const product_details = {
                    ...item,
                    tax: null,
                    quantity: 1,
                    total: 0,
                    total_tax: 0,
                    isFetching: false
                }

                this.product[index].isFetching = false
                this.product.splice(index, 0, product_details)
                this.product[index].product_name_copy = item.product_name
                this.product[index].description = item.product_name

            },
            deleteProduct(index) {
                if (index == 0 && this.product.length == 0) {
                    this.product.splice(index, 0, {
                        isFetching: false
                    })
                    this.product.splice(index + 1, 1)
                } else if (index == this.product.length - 1) {
                    return
                } else {
                    this.product.splice(index, 1)

                }
            },
            loadInvoiceNo() {
                this.$store.dispatch('getInvoiceNo')
                    .then(() => {
                        this.invoice_data.invoiceNumber = `B2C${this.$store.state.invoiceNo}`
                    }).catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {

                    })
            },
            newInvoice() {
                // clear values
                this.$router.go()
            },
            addCustomProduct(index) {
                this.$buefy.dialog.prompt({
                    message: 'Add new product',
                    inputAttrs: {
                        placeholder: 'King Plastic Broom',
                        value: this.name
                    },
                    confirmText: 'Add',
                    onConfirm: (value) => {
                        const product_details = {
                            product_name: "",
                            wholesale_price: "",
                            retail_price_alpha: "",
                            tax: null,
                            quantity: 1,
                            total: 0,
                            total_tax: 0,
                            isFetching: false
                        }

                        this.product[index].isFetching = false
                        this.product.splice(index, 0, product_details)
                        this.product[index].product_name_copy = value
                        this.product[index].description = value
                    }
                })
            }
        },
        mounted() {
            this.loadInvoiceNo()

        },
        computed: {
            invoiceNoComputed: {
                get() {
                    return `B2C${this.$store.state.invoiceNo}`
                },
                set(invoice_number) {
                    this.invoice_data.invoiceNumber = invoice_number
                    let temp_invoice_number = this.invoice_data.invoiceNumber.split('B2C')['1']

                    this.$store.state.invoiceNo = temp_invoice_number
                }

            },
            grandTotal: {
                get() {
                    let product_copy = []
                    Object.assign(product_copy, this.product)
                    product_copy.splice(product_copy.length - 1, 1)

                    let grand_total = 0

                    if (this.priceType == 'retail') {
                        product_copy.forEach((product) => {
                            grand_total += (product.retail_price_alpha * product.quantity * (product.tax) / 100) + product.retail_price_alpha * product.quantity
                        })
                    } else {
                        product_copy.forEach((product) => {
                            grand_total += (product.wholesale_price * product.quantity * (product.tax) / 100) + product.wholesale_price * product.quantity
                        })
                    }

                    return grand_total
                }
            },
        }

    }
</script>

<style>
.custom-background-autocomplete.autocomplete .dropdown-item.is-hovered{
    background: #B5B5CE;
}
</style>>

